

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

import{PharmacyIndentDetails} from '../../interfaces/masters/pharmacyindentdetails';



export interface PharmacyIndentParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;

}

export interface PharmacyIndent {

    id?: string;
    phIndentId?:Number;
    phIndentNo?:string;
    phIndentDate: any;
    phIndentFrom: string;
    regId: string;
    admissionId: Number;
    customerId: Number;
    visitId: Number;
     phIndentStatus: string;
    approvalDate: string;
    createdBy?: any;
    createdDate: any;
    updatedBy?: number;
    updatedDate?: Date;
    phIndentDeliveryInstructions: string;
    phIndentNotes: string;
    phIndentCompletedDate: string;
    phIndentApproveStatus: string;
    phIndentApproveby: string;
    tenantId: string;
    branchId: string;

    phdoctorid:string;
    phBillId:string;

    // discount fields:-
    totalDiscounttype?:string;
    totalDiscountPer?:number;
    totalDiscountAmt?:number;

    archiveFlag?: string,
    archiveDoneby?: number,
    archiveDonedatetime?: Date,
    phEmployeeId?:string,
    phIndentSubType:boolean,
    nurseId?:string,
    phPurpose?:number,
    phIndentPriority?:number
    phHoldBillId?:string
    phIndentDetDetDto: PharmacyIndentDetails[];
    prescriptionIds:string[],
    parameters?: PharmacyIndentParameter[];
    links?: any;
    nphiesStatus:string;
}

export abstract class PharmacyIndentData {

  abstract list(url: string): Observable<PharmacyIndent[]>;
  abstract create(url: string,data: any): Observable<any>;
  abstract update(url: string,data: PharmacyIndent): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract updateStatus(url: string,data: any): Observable<any>;
}
